import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15.5 5.734H14V4c0-2.2-1.8-4-4-4H8C5.8 0 4 1.8 4 4v1.734H2.5c-.825 0-1.5.675-1.5 1.5V16.5c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5V7.234c0-.825-.675-1.5-1.5-1.5zM5.2 4c0-1.544 1.256-2.8 2.8-2.8h2c1.544 0 2.8 1.256 2.8 2.8v1.734h-1.2V4c0-.882-.718-1.6-1.6-1.6H8c-.882 0-1.6.718-1.6 1.6v1.734H5.2V4zm5.2 0v1.734H7.6V4c0-.217.183-.4.4-.4h2c.217 0 .4.183.4.4zm5.4 12.5c0 .163-.137.3-.3.3h-13a.304.304 0 0 1-.3-.3V7.234c0-.163.137-.3.3-.3h13c.163 0 .3.137.3.3V16.5zM8.4 14h1.2v-4H8.4v4z" />
  </svg>
);

export default SvgComponent;
